import { DataSampleUnit } from "../types";

/** Normalize direction into 0–359 degrees */
export function normalizeDirection(deg: number): number {
    let d = deg % 360;
    if (d < 0) d += 360;
    return d;
}

export function getWindDirectionText(windDir: number, abbr: boolean): string {
	let directionText = abbr ? "N" : "North";

	if (windDir > 11.25 && windDir <= 33.75) {
		directionText = abbr ? "NNE" : "North-Northeast";
	} else if (windDir > 33.75 && windDir <= 56.25) {
		directionText = abbr ? "NE" : "Northeast";
	} else if (windDir > 56.25 && windDir <= 78.75) {
		directionText = abbr ? "ENE" : "East-Northeast";
	} else if (windDir > 78.75 && windDir <= 101.25) {
		directionText = abbr ? "E" : "East";
	} else if (windDir > 101.25 && windDir <= 123.75) {
		directionText = abbr ? "ESE" : "East-Southeast";
	} else if (windDir > 123.75 && windDir <= 146.25) {
		directionText = abbr ? "SE" : "Southeast";
	} else if (windDir > 146.25 && windDir <= 168.75) {
		directionText = abbr ? "SSE" : "South-Southeast";
	} else if (windDir > 168.75 && windDir <= 191.25) {
		directionText = abbr ? "S" : "South";
	} else if (windDir > 191.25 && windDir <= 213.75) {
		directionText = abbr ? "SSW" : "South-Southwest";
	} else if (windDir > 213.75 && windDir <= 236.25) {
		directionText = abbr ? "SW" : "Southwest";
	} else if (windDir > 236.25 && windDir <= 258.75) {
		directionText = abbr ? "WSW" : "West-Southwest";
	} else if (windDir > 258.75 && windDir <= 281.25) {
		directionText = abbr ? "W" : "West";
	} else if (windDir > 281.25 && windDir <= 303.75) {
		directionText = abbr ? "WNW" : "West-Northwest";
	} else if (windDir > 303.75 && windDir <= 326.25) {
		directionText = abbr ? "NW" : "Northwest";
	} else if (windDir > 326.25 && windDir <= 348.75) {
		directionText = abbr ? "NNW" : "North-Northwest";
	}

	return directionText;
};
